import { motion } from "framer-motion";

const partners = [
  {
    quote:
      "Collaborating with Cabptoid on our Salesforce integration was a game-changer. Their team brought deep expertise and delivered a seamless CRM solution that transformed how we manage customer relationships and drive business growth.",
    name: "Atenas Code Team",
    title: "Technology Partner",
    company: "Atenas Code",
    website: "https://www.atenascode.com",
    logo: "AC",
  },
  {
    quote:
      "Cabptoid's Salesforce expertise perfectly complemented our ERP and CRM services. Together we delivered a robust, scalable solution for our clients — on time and beyond expectations. A truly reliable technology partner.",
    name: "Sesat Solutions Team",
    title: "IT Solutions Partner",
    company: "Sesat Solutions",
    website: "https://www.sesatsolutions.com",
    logo: "SS",
  },
];

function Testimonials() {
  return (
    <section className="testimonials">
      <motion.div
        className="section-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <span className="section-tag">Partners</span>
        <h2 className="section-title">What Our Partners Say</h2>
        <p className="section-subtitle">
          Trusted by leading technology companies across the globe
        </p>
      </motion.div>

      <div className="testimonials-grid">
        {partners.map((partner, index) => (
          <motion.div
            key={index}
            className="testimonial-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <div className="testimonial-quote-icon">"</div>
            <p className="testimonial-text">{partner.quote}</p>
            <div className="testimonial-author">
              <div className="partner-logo-avatar">{partner.logo}</div>
              <div>
                <h4 style={{ margin: 0, color: "#fff" }}>{partner.name}</h4>
                <span
                  style={{ fontSize: "14px", color: "var(--text-secondary)" }}
                >
                  {partner.title}
                </span>
                <div>
                  <a
                    href={partner.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="partner-website-link"
                  >
                    {partner.company} ↗
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;